import {Button} from '@mui/material';
import React from 'react';

import {EmptySearchState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {ChatRoomsEnum} from 'presentation/constants';
import {useCallChatRoom, useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {StyledContainer} from './styles';

const {title, description} = translations['pt-br'].privateFlow.services.emptyState;
const {callToChat, clearFilter} = translations['pt-br'].commons;

export const EmptyState = () => {
	const {clearSearch} = useQueryParams();
	const {callChatRoom, IS_LOADING: isChatLoading} = useCallChatRoom();

	function handleCallChatRoom() {
		callChatRoom(ChatRoomsEnum.APP);
	}

	return (
		<StyledContainer>
			<EmptySearchState
				title={title}
				description={description}
				customMargin="0"
				customMaxWidthCard={'auto'}
				customMaxWidthContent={506}>
				<Button variant="contained" size="large" onClick={clearSearch}>
					{clearFilter}
				</Button>

			<Button variant="outlined" size="large" onClick={handleCallChatRoom} endIcon={isChatLoading ? <Loading size={16} color="inherit" /> : null}>
					{callToChat}
				</Button>
			</EmptySearchState>
		</StyledContainer>
	);
};
